import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 10px;
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
  font-size: 14px;
`;

export const CharacterCount = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${ColorSF2.white};
  padding: 0 5px;
  font-size: 10px;
  color: ${ColorSF2.mediumGray};
`;
